export default __webpack_public_path__ + "static/media/list.5f8b03bd.svg";